import {React, useEffect, useState} from "react";

import Index from "./pages/index";
import Home from "./pages/home";
import Report1 from "./pages/Report1";
import Report2 from "./pages/Report2";
import Report3 from "./pages/Report3";
import Report4 from "./pages/Report4";

export default function Davis() {
    const [activeTab, setActiveTab] = useState("index");

    return (
        <div>
            {/* Main content */}
            <main style = {{margin: "0px", padding: "0px"}}>
                {activeTab === "index" && <Index enterLog = {() => setActiveTab("home")}/>}
                {activeTab === "home" && <Home openReport1={() => setActiveTab("report1")}
                                               openReport2={() => setActiveTab("report2")}
                                               openReport3={() => setActiveTab("report3")}
                                               openReport4={() => setActiveTab("report4")}/>}
                {activeTab === "report1" && <Report1 goHome ={() => setActiveTab("home")}/>}
                {activeTab === "report2" && <Report2 goHome ={() => setActiveTab("home")}/>}
                {activeTab === "report3" && <Report3 goHome ={() => setActiveTab("home")}/>}
                {activeTab === "report4" && <Report4 goHome ={() => setActiveTab("home")}/>}
            </main>
        </div>
  );
}
